var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.375 15.4814C1.075 15.4814 0.8125 15.3689 0.5875 15.1439C0.3625 14.9189 0.25 14.6564 0.25 14.3564V3.0502H1.375V14.3564H10.2625V15.4814H1.375ZM3.625 13.2314C3.325 13.2314 3.0625 13.1189 2.8375 12.8939C2.6125 12.6689 2.5 12.4064 2.5 12.1064V1.60645C2.5 1.30645 2.6125 1.04395 2.8375 0.818945C3.0625 0.593945 3.325 0.481445 3.625 0.481445H11.875C12.175 0.481445 12.4375 0.593945 12.6625 0.818945C12.8875 1.04395 13 1.30645 13 1.60645V12.1064C13 12.4064 12.8875 12.6689 12.6625 12.8939C12.4375 13.1189 12.175 13.2314 11.875 13.2314H3.625Z",
  fill: "#757575"
});

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.4a143ac61bab553db13b63aadeaeb708.svg";
export { ForwardRef as ReactComponent };